import Paragraph from '../../Typography/Paragraph';
import classNames from 'classnames';
import { Check, Plus, Edit2 } from 'react-feather';
import Button from '../../Button';
var classes = {
    base: 'rounded-lg border border-gray-300 bg-white p-4 cursor-pointer flex flex-col group',
    filled: 'bg-gray-100',
};
var CardProfile = function (_a) {
    var title = _a.title, description = _a.description, filled = _a.filled, icon = _a.icon, onClick = _a.onClick;
    var Icon = icon;
    var handleClick = function () {
        onClick && onClick();
    };
    return (<div onClick={handleClick} className={classNames(classes.base, filled && classes.filled)}>
      <div className="flex w-full items-center">
        <div className="mr-3 flex h-10 w-10 flex-none items-center justify-center rounded-full bg-secondary-01-light">
          <Icon size={24} className="fill-white text-white"/>
        </div>
        <Paragraph className="font-medium">{title}</Paragraph>
        {filled && (<div className="ml-auto flex h-6 w-6 items-center justify-center rounded-full bg-alert-success">
            <Check size={16} className="text-white"/>
          </div>)}
      </div>
      <Paragraph className="mt-3 mb-auto text-gray-700" size="xs">
        {description}
      </Paragraph>
      <Button className="mt-6 self-start text-brand-02" type="inline" icon={filled ? Edit2 : Plus} side="start">
        {filled ? 'Modifier' : 'Ajouter'}
      </Button>
    </div>);
};
export default CardProfile;
